// frontend/src/services/auth.js

/**
 * Get the current authentication token from localStorage
 */
export function getAuthToken() {
  return localStorage.getItem('token');
}

/**
 * Set the authentication token in localStorage
 */
export function setAuthToken(token) {
  if (token) {
    localStorage.setItem('token', token);
  } else {
    localStorage.removeItem('token');
  }
}

/**
 * Remove the authentication token from localStorage
 */
export function removeAuthToken() {
  localStorage.removeItem('token');
}
